import { INTERVIEW_TYPE_ONLINE } from 'researcher/project_constants';

export const isOnline = (project) =>
  project?.interviewTypeId === INTERVIEW_TYPE_ONLINE.id;
